module.exports = __webpack_public_path__ + "img/1.26e8bc7b.jpg";